import { GET_TIPOS_ZONA, ADD_TIPO_ZONA, MODIFY_TIPO_ZONA, DELETE_TIPO_ZONA, UPDATE_TIPOS_ZONA } from '../constants/action_types';

const initialState = {
    tiposzona: [],
    isLoading: false
};

export default function (state = initialState, action) {


    switch (action.type) {
        case GET_TIPOS_ZONA:

            return {
                tiposzona: [],
                isLoading: true
            };

        case GET_TIPOS_ZONA + "_SUCCESS":

            return {
                tiposzona: action.payload.data,
                isLoading: false
            };

        case ADD_TIPO_ZONA:

            const newArr = [...state.tiposzona, action.payload]
            return {
                tiposzona: newArr,
                isLoading: false
            };

        case MODIFY_TIPO_ZONA:

            return {
                tiposzona: state.tiposzona.map((tipoZona) => {
                    if (tipoZona.id !== action.payload.id) return tipoZona;
                    else return action.payload
                }),
                isLoading: false
            };

        case DELETE_TIPO_ZONA:
            return {
                tiposzona: state.tiposzona.filter(tipoZona => tipoZona.id !== action.payload.id),
                isLoading: false
            };

        case UPDATE_TIPOS_ZONA + "_SUCCESS":

            return state;

        default:

            return state;
    }
}